import { vars } from "@donaswap/ui/css/vars.css";

export const lightColors = vars.colors;

export const darkColors = vars.colors;

export const fireColors = vars.colors;
